import { useEffect, useMemo, useState } from "react";
import defaultAxios from "../../commons/utils/axios";
import {
  ADD_PRODUCT_IN_GROUP_MENU,
  GROUP_MENU_DETAIL,
  REMOVE_PRODUCT_IN_GROUP_MENU,
} from "../../commons/constants/api-urls";
import { message } from "antd";

const useGroupMenu = () => {
  const [dataSrc, setDataSrc] = useState<ProductMenu[]>([]);
  const [dataSelected, setDataSelected] = useState<number[]>([]);
  const [dataUnSelected, setDataUnSelected] = useState<number[]>([]);
  const [menuDetail, setMenuDetail] = useState<GroupMenuDetail>();
  const [openModal, setOpenModal] = useState(false);
  const [isAdd, setIsAdd] = useState(false);
  async function getGroupMenuDetail(storeId: string, menuId: string) {
    const { data } = await defaultAxios.get<GroupMenuDetail>(GROUP_MENU_DETAIL(storeId, menuId));
    setMenuDetail(data);

    return data;
  }

  function getBody(values: { "group-name": string }) {
    const body = {
      name: values["group-name"],
      productIds: dataSelected,
    };
    return body;
  }

  function getBodyEdit(values: { "group-name": string }) {
    const body = {
      name: values["group-name"],
    };
    return body;
  }

  function getListProduct(data: ProductItem[]) {
    console.log({ data });
    const dataSrc = data.map((product, idx) => {
      const isGrouped = dataSelected.includes(product.id);
      return {
        key: product.id,
        name: product.name,
        images: product.images,
        id: product.id,
        groupMenuId: product.groupMenuId,
        total_sales: product.total_sales,
        price: product.price,
        isFeatured: product.settings["is_featured"],
        isPreviewing: product.isPreviewing,
        isGrouped: isGrouped,
        idx: idx,
      };
    });
    setDataSrc(dataSrc);
  }

  function initDataSelected(data: ProductItem[]) {
    const dataGrouped = data.filter(item => item.groupMenuId && !dataUnSelected.includes(item.id)).map(item => item.id);
    let dataInit = [...dataSelected, ...dataGrouped];

    const uniq = Array.from(new Set(dataInit));

    setDataSelected(uniq);
  }

  const handleMarkProductReview = (productId: number, isGrouped: boolean) => {
    if (isGrouped) {
      setDataSelected(prev => {
        const dataSelect = [...prev];
        return dataSelect.filter(item => {
          return item !== productId;
        });
      });
      setDataUnSelected([...dataUnSelected, productId]);
      setIsAdd(false);
    } else {
      setDataSelected([...dataSelected, productId]);
      setDataUnSelected(prev => {
        const dataUnSelect = [...prev];
        return dataUnSelect.filter(item => {
          return item !== productId;
        });
      });
      setIsAdd(true);
    }
    setOpenModal(true);
  };

  const handleEditMarkProductReview = async (
    productId: number,
    storeId: string,
    groupid: string,
    isGrouped: boolean,
    setLoading: any
  ) => {
    try {
      setLoading(true);
      if (!isGrouped) {
        await defaultAxios.post(ADD_PRODUCT_IN_GROUP_MENU(storeId, groupid), {
          productId,
        });
        setMenuDetail(prev => {
          return { ...prev!, productQuantity: prev!.productQuantity + 1 };
        });
        // setIsAdd(true);
      } else {
        await defaultAxios.post(REMOVE_PRODUCT_IN_GROUP_MENU(storeId, groupid), {
          productId,
        });
        setMenuDetail(prev => {
          return { ...prev!, productQuantity: prev!.productQuantity - 1 };
        });
        // setIsAdd(false);
      }
      handleMarkProductReview(productId, isGrouped);

      // setOpenModal(true);
    } catch (error) {
      message.error("Edit group failed");
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return {
    getBody,
    getListProduct,
    dataSrc,
    handleMarkProductReview,
    dataSelected,
    initDataSelected,
    setDataSelected,
    menuDetail,
    getGroupMenuDetail,
    handleEditMarkProductReview,
    getBodyEdit,
    openModal,
    setOpenModal,
    isAdd,
  };
};

export default useGroupMenu;
